export const ValidationTestType = {
	Liveness: 'Liveness',
	FaceMatch: 'FaceMatch',
	// Same:
	DocumentValidation: 'DocumentValidation',
	DocumentVerification: 'DocumentVerification',
} as const;
export type ValidationTestType = (typeof ValidationTestType)[keyof typeof ValidationTestType];

/*--------------------------------------------*/
export const ValidationTestTypeDependOnFieldType: Exclude<ValidationTestType, 'Liveness'>[] = [ValidationTestType.DocumentVerification, ValidationTestType.FaceMatch];
